module.exports = __webpack_public_path__ + "img/KirbyTracker.db6ef43f.jpg";